import './Stat.scoped.scss'
import PopoverLink from './PopoverLink/PopoverLink'

export default function Stat({ size = 'normal', searchId = '', borderBottom=true, number=null, icon, primary, secondary, label, showPulse = false, popover = null }) {
  function statContent() {
    return <>
      <p className='primary break-word'>
        { showPulse && <div className="pulser margin-right"></div> }
        { Number.isInteger(primary) ? primary.toLocaleString() : primary }
      </p>
      { number !== null && <p className='number'>{ number.toLocaleString() }</p> }
      { label && <div className="label">
          <p>
            { popover && (
              <PopoverLink content={popover.content} noQuestionIcon className="popover-link">
                <SvgIconsQuestion width={18} height={18} className="popover-icon" />
                <span>{ label }</span>
              </PopoverLink>
            )}
            { !popover && label }
          </p>
      </div> }
    </>
  }

  const path = `/admin/searches/${searchId}`;
  return <div className={`text-stat ${size} ${borderBottom ? 'border-bottom' : ''}`}>
      { icon && <div className={`icon ${size}`}>{ icon }</div> }
      { !searchId && <div className='content'>
            { statContent() }
      </div> }
      { searchId && <a href={path} className='content'>
            { statContent() }
      </a> }
  </div>  
}
